<h1 class="title">Work Types</h1>
<h5>Manage Work Types, Categories, and Classifications</h5>

<ng-container *ngIf="!isLoading else showLoader">
    <acabim-datatable
        #dataTable
        [dataSources]="dataTableSources"
        [dataKey]="'id'"
        [helpMessage]="helpMessage"
        (details)="setSelectedDetails($event)"
        (showDetail)="showDetails($event)"
        [hasDetailView]="true">
    </acabim-datatable>
    <div class="cas-action-buttons">
        <button class="cas-button-action cas-button-right" (click)="add()">Add</button>
    </div>

    <ng-container *ngIf="loadDetails && selectedDetails">
        <acabim-modal
            [display]="loadDetails"
            [title]="'Editing: ' + selectedDetails?.name"
            (status)="closeDetailsModal($event)"
            fixHeight="65vh"
            width="60vw">
            <acabim-admin-work-order-type-details
                [workTypeData]="selectedDetails"
                (cancelled)="closeDetailsModal($event)"
                (completed)="completeDetailsModal($event)"></acabim-admin-work-order-type-details>
        </acabim-modal>
    </ng-container>

    <acabim-modal
        [display]="addWorkType"
        [title]="'Add work type'"
        (status)="closeAddModal($event)"
        fixHeight="60vh"
        width="60vw">
        <acabim-admin-work-order-type-details
            [workTypeData]="null"
            (cancelled)="closeAddModal($event)"
            (completed)="completeAddModal($event)"></acabim-admin-work-order-type-details>
    </acabim-modal>
</ng-container>

<ng-template #showLoader>
    <acabim-loading-view></acabim-loading-view>
</ng-template>
